import classNames from 'classnames';
import { useDeviceDetect } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import BlockedCountryImage from 'src/assets/images/blockedCountry.webp';

export const BlockedCountryPlug = () => {
  const { t } = useTranslation();
  const { isMobile } = useDeviceDetect();

  return (
    <div className="blocked-country-wrapper flex flex-col justify-start h-screen bg-[top_center] w-full 768:gap-4 items-center bg-BLOCKED_COUNTRY min-h-[950px] bg-no-repeat bg-cover gap-2">
      <h3
        className={classNames(
          'text-bc_error text-4xl 768:text-5xl font-extrabold',
          isMobile ? 'landscape:pt-6' : 'pt-[125px] 768:pt-[137px]'
        )}>
        403
      </h3>
      <h2 className="capitalize text-bc_text text-2xl 768:text-4xl font-extrabold">
        {t('apiErrors.forbidden')}
      </h2>
      <p className="first-letter:uppercase text-bc_text text-base 768:text-2xl font-normal max-w-[465px] text-center w-[80%] 768:w-full">
        {t('general.blockedCountry')}
      </p>
      <img
        src={BlockedCountryImage}
        className="w-[318px] h-[376px] 768:w-[500px] 768:h-[525px]"
        alt="wizard"
      />
    </div>
  );
};
